import React from "react";
import { connect } from "react-redux";
import ShadowedContainer from "./../shared/containers/ShadowedContainer";
import Store from "../../content/Store";
import Contentify from "../../content/Contentify";
import Notification from "./Notification";
import style from "../../assets/css/modules/notifications/notifications.css";
import { removeNotificationBySecurityId } from "../../actions/notifications/notificationsAction";
import InfoBox from "../shared/InfoBox";

export const Notifications = ({
  content,
  notifications,
  removeNotificationBySecurityId
}) => (
  <div className={style.notifications}>
    <div className="container">
      <h1 className={style.header}>{content.heading}</h1>
    </div>
    <ShadowedContainer>
      <p className={style.subHeading}>{content.subHeading}</p>
      <div className={style.notificationWrapper}>
        {notifications && notifications.length && notifications.length > 0 ? (
          notifications.map((notification) => (
            <Notification
              key={notification && notification.InvoiceReference}
              notification={notification}
              content={content.notification}
              removeNotification={() =>
                removeNotificationBySecurityId(notification.SecurityId)
              }
            />
          ))
        ) : (
          <InfoBox iconClass={"icon-help-outline " + style.iconStyle}>
            <div className={style.infoBoxContent}>
              {content.noNotificationsMessage}
            </div>
          </InfoBox>
        )}
      </div>
    </ShadowedContainer>
  </div>
);

Notifications.content = Store.Notifications;

export const mapStateToNotifications = ({ notificationsReducer }) => ({
  notifications:
    notificationsReducer.selectedPolicy &&
    notificationsReducer.selectedPolicy.notifications
});

export default connect(mapStateToNotifications, {
  removeNotificationBySecurityId
})(Contentify(Notifications));
